export default {
  list: (state) => {
    return state.list;
  },
  loading: (state) => {
    return state.loading;
  },
  goodCauseById: (state) => (id) => {
    return state.list.find((goodCause) => {
      return goodCause.id === id;
    });
  },
  currentProfile: (state) => {
    return state.currentProfile;
  },
  approved: (state) => {
    let activeList = state.list.filter((goodCause) => {
      return (
        !goodCause.name.includes("( Impact an Area )") &&
        !goodCause.name.includes("( Impacts Overall )") &&
        goodCause.status === "Approved & Live"
      );
    });
    return activeList;
  },
  listOrderedByCategories: (state) => {
    let goodCauses = JSON.parse(JSON.stringify(state.list));
    let newList = goodCauses.filter(
      (gc) =>
        (gc.name.includes("( Impact an Area )") ||
          gc.name.includes("( Impacts Overall )")) &&
        gc.status === "Approved & Live"
    );

    goodCauses.forEach((element) => {
      if (
        !element.name.includes("( Impact an Area )") &&
        !element.name.includes("( Impacts Overall )") &&
        element.status === "Approved & Live"
      ) {
        newList.push(element);
      }
    });

    return newList;
  },
};
